import styled from '@emotion/styled'
import {
  LoyaltyCard,
  PotentialLoyaltyGains as PotentialLoyaltyGainsType,
  Summary
} from 'shop/types/cart'
import Discount from '../Discount/Discount'
import FeeBreakdown from './FeeBreakdown'
import { Rewards } from '../Loyalty'
import { getApplicableRewards } from 'shop/components/Checkout'
import { FulfillmentType } from 'shop/types'
import { getFulfillmentFlags, getAppliedRewardDiscount } from 'shop/utils/cart'
import CartBreakdownItem from './CartBreakdownItem'
import PotentialLoyaltyGains from 'shop/components/ShopCart/PotentialLoyaltyGains'
import { LineBreak } from 'shop/components/Shop/commonStyles'

interface Props {
  loyaltyCards?: LoyaltyCard[]
  summary: Summary
  fulfillmentType: FulfillmentType
  potentialLoyaltyGains?: PotentialLoyaltyGainsType
  isEditable?: boolean
  isCartLoading?: boolean
}

const CartBreakdown = ({
  summary,
  loyaltyCards,
  fulfillmentType,
  potentialLoyaltyGains,
  isEditable = false,
  isCartLoading = false
}: Props) => {
  const { discount, reward, storeFee, delivery, tip, subtotal, total } = summary
  const showPotentialLoyaltyGains =
    potentialLoyaltyGains &&
    !!(
      potentialLoyaltyGains.points?.total || potentialLoyaltyGains.stamps?.total
    )
  const { isDelivery } = getFulfillmentFlags(fulfillmentType)

  const showDiscount = isEditable || !!discount

  const applicableRewards = getApplicableRewards(loyaltyCards)
  const showRewards = isEditable && !!applicableRewards?.length

  const appliedRewardDiscount = getAppliedRewardDiscount(reward, discount)

  return (
    <BreakdownSection data-testid='cart-breakdown'>
      {showRewards && (
        <Rewards rewards={applicableRewards} appliedReward={reward}></Rewards>
      )}
      {showDiscount && (
        <Discount
          isEditable={isEditable}
          discount={appliedRewardDiscount}
          hasRewards={showRewards}
        />
      )}
      {showPotentialLoyaltyGains && (
        <PotentialLoyaltyGainsSection>
          <LineBreak height={'2px'} />
          <PotentialLoyaltyGains
            potentialLoyaltyGains={potentialLoyaltyGains}
          />
        </PotentialLoyaltyGainsSection>
      )}
      <CartBreakdownItem
        fontWeight={500}
        label={'Subtotal'}
        price={subtotal}
        isCartLoading={isCartLoading}
        lineBreakHeight={'2px'}
      />
      <FeeBreakdown
        storeFee={storeFee}
        isDelivery={isDelivery}
        deliveryFee={delivery}
        tip={tip}
        isCartLoading={isCartLoading}
        isEditable={isEditable}
      />
      <CartBreakdownItem
        fontWeight={600}
        fontSize={20}
        label={'Total'}
        price={total}
        lineBreakHeight={'2px'}
        isCartLoading={isCartLoading}
      />
    </BreakdownSection>
  )
}

const BreakdownSection = styled.div(() => ({
  '> div:last-of-type > div': {
    paddingBottom: '0'
  }
}))

const PotentialLoyaltyGainsSection = styled.div(() => ({
  '> div': {
    padding: '16px 0'
  }
}))

export default CartBreakdown
